import { Play, ExternalLink } from "lucide-react";

const REEL_URL = "https://www.facebook.com/reel/232805032778074";
const EMBED_URL = `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(
  REEL_URL
)}&show_text=0&width=560&autoplay=false`;

export default function VideoReel() {
  return (
    <section data-testid="reel-section" className="bg-[var(--ink)] text-[var(--bone)] py-24 md:py-32 relative overflow-hidden">
      <div className="grain absolute inset-0 opacity-40" />
      <div className="container-x relative grid grid-cols-12 gap-10 items-center">
        <div className="col-span-12 md:col-span-5">
          <div className="overline text-[var(--terracotta)] inline-flex items-center gap-2">
            <Play className="w-3.5 h-3.5 fill-[var(--terracotta)]" /> Watch · 60 seconds
          </div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl mt-5 leading-[1.0] tracking-[-0.025em]">
            Sixty seconds from <em className="text-[var(--terracotta)] not-italic">the field.</em>
          </h2>
          <p className="text-[var(--bone)]/70 mt-6 leading-relaxed">
            Words can do only so much. Watch what happens when a community rebuilds a
            classroom — together, in real time. Filmed on-site, unedited.
          </p>
          <a
            href={REEL_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="reel-watch-fb"
            className="inline-flex items-center gap-2 mt-8 text-[var(--terracotta)] hover:underline"
          >
            Watch on Facebook <ExternalLink className="w-4 h-4" />
          </a>
        </div>

        <div className="col-span-12 md:col-span-7">
          <div className="relative w-full bg-black aspect-[9/16] md:aspect-video max-w-md mx-auto md:max-w-full border border-[var(--bone)]/15">
            <iframe
              title="Irene Foundation field reel"
              src={EMBED_URL}
              className="absolute inset-0 w-full h-full"
              frameBorder="0"
              allowFullScreen
              allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
              scrolling="no"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
